import DeductionsModel from '../Apis/Deductions'
import Controller from './Controller'

export default class DeductionsController extends Controller {
  constructor() {
    super(new DeductionsModel())
  }
}
